export let speechLanguageMenu = [
    'English',
    'Hindi',
    'Kannada',
    'Telugu',
    'Odia',
    'Marathi',
    'Malayalam',
]

var playInitialState = {
    speech: {
        language: 'English',
        actionsMap: { English: [] },
    },
}
const reduxPlayStore = sessionStorage.getItem('reduxPlayStore')
try {
    if (reduxPlayStore) {
        playInitialState = JSON.parse(reduxPlayStore)
    }
} catch (e) {
}

const playModeReducer = (state = playInitialState, action) => {
    switch (action.type) {
        case 'SET_LANGUAGE': {
            let data = JSON.parse(JSON.stringify(state))
            data.speech.language = action.payload
            sessionStorage.setItem('reduxPlayStore', JSON.stringify(data))
            return data
        }
        case 'SET_ACTIONS_MAP': {
            let data = JSON.parse(JSON.stringify(state))
            let selectedLanguage = data.speech.language
            data.speech.actionsMap[selectedLanguage] = action.payload
            sessionStorage.setItem('reduxPlayStore', JSON.stringify(data))
            return data
        }

        default:
            return state
    }
}

export default playModeReducer
